// Unpublished Work © 2021-2025 Deere & Company.

export const CSCMessageTypes = {
    ADD_CUSTOMER: 'csc-add-customer',
    ADD_NEW_CUSTOMER: 'csc-add-new-customer',
    BUSINESS_CONTACT_SELECTED: 'csc-business-contact-selected',
    CANCEL_SEARCH: 'csc-cancel-search',
    CANCEL_ADD_CUSTOMER: 'csc-cancel-add-customer',
    EDIT_CUSTOMER: 'csc-edit-customer',
    GO_TO_ADD_NEW_CUSTOMER: 'csc-go-to-add-new-customer',
    GO_BACK_TO_CONTEXT: 'csc-go-back-to-context',
    LOADED: 'csc-loaded',
    UPDATE_DBS_SELECTION: 'csc-update-dbs-selection',
    UPDATE_ORG_SELECTION: 'csc-update-org-selection'
};
